import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * パンク
 */
const FlatTireIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g transform="translate(-12 -231)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(12 231)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <g transform="translate(-101 41.359)">
            <path
              d="M212.443,282.794a7.992,7.992,0,0,0-13.869,6.25,7.912,7.912,0,0,0,1.011,3.094,7.991,7.991,0,0,0,13.889,0,7.955,7.955,0,0,0-1.031-9.345Zm-5.914-1.191a6.521,6.521,0,0,1,2.7.586,2.76,2.76,0,0,1-5.4,0A6.523,6.523,0,0,1,206.529,281.6ZM200,288.889a6.625,6.625,0,0,1-.041-.716,6.535,6.535,0,0,1,1.717-4.412A2.761,2.761,0,0,1,200,288.889Zm5.192,5.715a6.583,6.583,0,0,1-4.362-3.178,2.761,2.761,0,0,1,4.362,3.178Zm1.848-4.856a1.657,1.657,0,1,1,1.065-2.087A1.656,1.656,0,0,1,207.041,289.747Zm.824,4.856a2.761,2.761,0,0,1,4.363-3.177A6.584,6.584,0,0,1,207.865,294.6Zm5.192-5.715a2.76,2.76,0,0,1-1.676-5.129,6.535,6.535,0,0,1,1.717,4.412A6.613,6.613,0,0,1,213.057,288.889Z"
              transform="translate(-78.249 -78.251)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <path
              d="M571.557,415.264l1.854,1.927-6.339,2.893Z"
              transform="translate(-423.521 -204.815)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <path
              d="M571.9,487.37l.433,2.239-7.6.49Z"
              transform="translate(-421.336 -272.367)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <path
              d="M565.545,561.485l-.606,1.778-6.263-1.7Z"
              transform="translate(-415.654 -341.802)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <path
              d="M139.434,217.123a13.279,13.279,0,1,0-24.434-7.2,14.85,14.85,0,0,0,4.444,9.752,1.048,1.048,0,0,0-.634,1.028c0,1.294,3.662,1.564,5.562,1.615.084,0,.168.008.251.008h.137c.168,0,.313,0,.428,0h7.732c1.31,0,5.975-.85,5.975-.85l-1.406-.97,3.007-.752-2.029-.649,2.029-1.543Zm-11.153,1.532a8.748,8.748,0,0,1-8.734-8.734c0-.055,0-.109,0-.163l0-.079a8.68,8.68,0,0,1,1.527-4.692,8.725,8.725,0,0,1,14.4,0,8.685,8.685,0,0,1,1.526,4.692l0,.08c0,.054,0,.108,0,.162a8.644,8.644,0,0,1-1.815,5.321,8.721,8.721,0,0,1-6.918,3.412Z"
              transform="translate(0 0)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default FlatTireIcon
